// A dónde va una persona cuando no se le dijo a dónde ir.
//
// SPEC_VISIBILIDAD_MODULOS_POR_ROL_v0.1.md · A-8, A-13
//
// **Tres lugares tomaban esta decisión y estaba escrita dos veces**: el
// destino post-login (`LoginView`) y el `homeLink` del logo (`AppNavbar`), con
// un comentario en el navbar advirtiendo que «si divergen, el logo lleva a un
// lado y el login a otro». El guard del router era el tercero, y usaba un
// literal distinto. Acá viven las tres.
//
// **Por qué dejó de alcanzar el criterio anterior.** Era:
//     ver_reportes -> /dashboard ; cobrar_deudas -> /cobranza ; si no -> /pantalla-inicio
// El último escalón era seguro sólo mientras `/pantalla-inicio` no comprobara
// permisos. Al gatearla (A-13) —era el terminal de venta abierto a cualquier
// autenticado— ese fallback se volvió una **trampa**: el guard rechaza, manda
// ahí, y ahí lo vuelve a rechazar. Medido contra el seed: **cinco de los ocho
// roles** —soporte_ventax, gerente, encargado_deposito, ayudante_deposito y
// vendedor— no tienen ni `crear_venta` ni `cobrar_venta`, así que caían en un
// bucle de redirección.
//
// La salida no es elegir otro literal —el próximo rol lo vuelve a romper—:
// es **derivar el destino del mismo modelo que arma el menú**. Si a alguien se
// le ofrece un ítem, ese ítem es alcanzable; si no se le ofrece ninguno, no hay
// destino que inventarle y vuelve al login.
// Import RELATIVO y no con el alias `@/`: ese alias lo resuelve webpack, y este
// módulo lo importa una prueba pura que corre en Node crudo. Es la misma
// restricción que impone la extensión `.mjs` — quien manda acá es Node, no el
// bundler.
import { MENU, itemVisible, seccionVisible } from '../constants/menuModules.mjs'

/**
 * @param {(permiso: string) => boolean} tiene
 * @returns {string} ruta a la que mandar a esta persona
 */
export function homeDestino(tiene) {
  // Preferencias explícitas, que son las que ya estaban y siguen valiendo:
  // gerencia entra por su tablero, y quien cobra entra por cobranza (D24).
  if (tiene('ver_reportes')) return '/dashboard'
  if (tiene('cobrar_deudas')) return '/cobranza'

  // Si no, el primer ítem que esa persona realmente ve en su menú.
  for (const seccion of MENU) {
    if (!seccionVisible(seccion, tiene)) continue
    const item = seccion.items.find((i) => itemVisible(i, tiene))
    if (item) return item.href
  }

  // Sin un solo ítem visible no hay pantalla que ofrecerle. Al login, que es
  // la única ruta pública — nunca a una que lo vaya a rechazar de nuevo.
  return '/'
}
